<template>
    <v-col class="pa-0">
        <v-card
            class="mx-auto pt-1"
            elevation="0"
            width="100%"
            :disabled="isLoading"
            :loading="isLoading"
        >
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" align="center">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            Cobertura de Objetivos
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                            "
                        >
                            <v-icon large> mdi-google-my-business </v-icon>
                            Cobertura de Objetivos
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-card-text>
                <v-sheet class="py-4">
                    <v-sheet tile class="mx-4">
                        <v-row>
                            <v-col cols="12" align="center">
                                <v-row>
                                    <v-slide-group
                                        v-model="selectedObjectiveIndex"
                                        class="pa-4"
                                        show-arrows
                                        mandatory
                                    >
                                        <v-slide-item
                                            v-for="(
                                                objetivo, key
                                            ) in consec_count"
                                            :key="key"
                                            v-slot="{ active, toggle }"
                                        >
                                            <v-chip
                                                :class="
                                                    $vuetify.breakpoint
                                                        .mdAndDown
                                                        ? 'ma-2 text-overline'
                                                        : 'ma-2'
                                                "
                                                :color="
                                                    active
                                                        ? 'primary darken-1'
                                                        : 'grey lighten-1'
                                                "
                                                :large="
                                                    !$vuetify.breakpoint
                                                        .mdAndDown
                                                "
                                                @click="toggle"
                                            >
                                                <div class="mx-3">
                                                    <span
                                                        class="
                                                            font-weight-light
                                                        "
                                                    >
                                                        {{
                                                            objetivo.name.replace(
                                                                '_',
                                                                ' '
                                                            )
                                                        }}
                                                    </span>
                                                    <v-icon right size="25">
                                                        mdi-bullseye-arrow
                                                    </v-icon>
                                                </div>
                                            </v-chip>
                                        </v-slide-item>
                                    </v-slide-group>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col
                                cols="12"
                                md="4"
                                :class="
                                    $vuetify.breakpoint.mdAndDown
                                        ? 'd-flex justify-space-around'
                                        : 'd-flex justify-space-around px-12 pl-0'
                                "
                            >
                                <v-card
                                    class="pa-4"
                                    outlined
                                    width="100%"
                                    elevation="0"
                                >
                                    <v-row>
                                        <v-col md="12">
                                            <h3
                                                class="
                                                    py-2
                                                    vcard-text-sm
                                                    text-center
                                                "
                                            >
                                                {{
                                                    consec_count.length
                                                        ? consec_count[
                                                              selectedObjectiveIndex
                                                          ].name.replace(
                                                              '_',
                                                              ' '
                                                          )
                                                        : ''
                                                }}
                                            </h3>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-divider class="test"></v-divider> -->
                                    <v-row
                                        style="height: 100%"
                                        class="d-flex align-center"
                                    >
                                        <v-col
                                            md="12"
                                            class="py-8"
                                            align="center"
                                        >
                                            <h3 class="display-2">
                                                {{
                                                    selectedObjective
                                                        ? selectedObjective.consecucion
                                                        : Object.keys(
                                                              consec_count
                                                          ) != 0
                                                        ? consec_count[
                                                              Object.keys(
                                                                  consec_count
                                                              )[0]
                                                          ].consecucion
                                                        : 0
                                                }}
                                                /
                                                {{
                                                    selectedObjective
                                                        ? selectedObjective.objetivo
                                                        : Object.keys(
                                                              consec_count
                                                          ) != 0
                                                        ? consec_count[
                                                              Object.keys(
                                                                  consec_count
                                                              )[0]
                                                          ].objetivo
                                                        : 0
                                                }}
                                            </h3>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-col
                                cols="12"
                                md="3"
                                align="center"
                                class="d-flex justify-center"
                            >
                                <v-progress-circular
                                    :rotate="270"
                                    :size="
                                        $vuetify.breakpoint.mdAndDown
                                            ? 150
                                            : 280
                                    "
                                    :width="
                                        $vuetify.breakpoint.mdAndDown ? 10 : 20
                                    "
                                    :value="valAnimated"
                                    :color="getColor(valAnimated)"
                                >
                                    <span
                                        :class="
                                            $vuetify.breakpoint.mdAndDown
                                                ? 'text-h5'
                                                : 'display-2'
                                        "
                                    >
                                        <div
                                            :class="
                                                $vuetify.breakpoint.mdAndDown
                                                    ? 'overline'
                                                    : ' overline mt-n6'"
                                        >
                                            Objetivo %
                                        </div>
                                        {{
                                            parseToFloatSpecialInteger(
                                                valAnimated
                                            ) + ' %'
                                        }}
                                    </span>
                                </v-progress-circular>
                            </v-col>
                            <v-col
                                cols="12"
                                md="3"
                                align="center"
                                class="d-flex justify-center"
                            >
                                <v-progress-circular
                                    :rotate="270"
                                    :size="
                                        $vuetify.breakpoint.mdAndDown
                                            ? 150
                                            : 280
                                    "
                                    :width="
                                        $vuetify.breakpoint.mdAndDown ? 10 : 20
                                    "
                                    :value="valAnimated1"
                                    :color="getColor(valAnimated1)"
                                >
                                    <span
                                        :class="
                                            $vuetify.breakpoint.mdAndDown
                                                ? 'text-h5'
                                                : 'display-2'"
                                    >
                                        <div
                                            :class="
                                                $vuetify.breakpoint.mdAndDown
                                                    ? 'overline'
                                                    : ' overline mt-n6'"
                                        >
                                            Proyección %
                                        </div>
                                        {{
                                            parseToFloatSpecialInteger(
                                                valAnimated1
                                            ) + ' %'
                                        }}
                                    </span>
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-sheet>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { mapState } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import { getWorkingDays, parseToFloatSpecialInteger } from '@/util/libUtil.js';

export default {
    name: 'DashBoardShopObjectives',

    data: () => ({
        commercialWorkingDays: 0,
        commercialWorkingDaysUntilToday: 0,
        date: new Date(),
        value: 0,
        valAnimatedAux: 0,
        value1: 0,
        valAnimatedAux1: 0,
        selectedObjectiveIndex: 0,
        selectedObjective: null,
    }),
    components: {
        LoadingSkeleton,
    },
    computed: {
        valAnimated: {
            get() {
                return this.valAnimatedAux.toFixed(2);
            },
            set(val) {
                if (!Number.isNaN(val)) {
                    let thisref = this;
                    let animate = () => {
                        setTimeout(function () {
                            if (thisref.valAnimatedAux >= val) {
                                thisref.valAnimatedAux = val;
                                return;
                            } else {
                                thisref.valAnimatedAux += 15.42;
                                animate();
                            }
                        }, 80);
                    };
                    animate();
                }
            },
        },
        valAnimated1: {
            get() {
                return parseFloat(this.valAnimatedAux1).toFixed(2);
            },
            set(val) {
                if (!Number.isNaN(val)) {
                    let thisref = this;
                    let animate = () => {
                        setTimeout(function () {
                            if (thisref.valAnimatedAux1 >= val) {
                                thisref.valAnimatedAux1 = val;
                                return;
                            } else {
                                thisref.valAnimatedAux1 += 15.42;
                                animate();
                            }
                        }, 80);
                    };
                    animate();
                }
            },
        },
        ...mapState('dashboard', {
            consec_total: (state) => state.estadisticaConsecucion.consecucion,
            isLoading: (state) => state.estadisticaConsecucion.isLoading,
            selectMonth: (state) => state.selectMonth,
        }),
        ...mapState('areaPersonal/calculadora', {
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        consec_count() {
            let elements = {};

            this.consec_total.forEach((element) => {
                if (element.familia in elements) {
                    elements[element.familia]['consecucion'] +=
                        element.consecucion;
                    elements[element.familia]['objetivo'] += element.objetivo;
                } else {
                    elements[element.familia] = {};
                    elements[element.familia]['consecucion'] =
                        element.consecucion;
                    elements[element.familia]['objetivo'] = element.objetivo;
                }
            });

            var sortable = [];
            Object.keys(elements).forEach((key) => {
                sortable.push({ name: key, ...elements[key] });
            });

            sortable.sort((a, b) =>
                a.consecucion < b.consecucion
                    ? 1
                    : b.consecucion < a.consecucion
                    ? -1
                    : 0
            );

            return sortable;
        },
    },
    created() {
        this.calculateCommercialDays();
    },
    methods: {
        parseToFloatSpecialInteger,
        calculateCommercialDays() {
            this.commercialWorkingDays = getWorkingDays(this.date);
            if (this.date < this.dateActualInmutable) {
                this.commercialWorkingDaysUntilToday = getWorkingDays(
                    this.date
                );
            } else {
                this.commercialWorkingDaysUntilToday = getWorkingDays(
                    this.date,
                    true
                );
            }
        },
        getColor(val) {
            return val < 30
                ? 'red darken-1 accent-3'
                : val < 50
                ? 'orange accent-3'
                : val < 80
                ? 'yellow darken-1'
                : 'green darken-3 accent-3';
        },
        getProyeccion(item) {
            return (
                (item.consecucion / this.commercialWorkingDaysUntilToday) *
                this.commercialWorkingDays
            ).toFixed(2);
        },
        getProyeccionPercent(item) {
            return item.objetivo != 0
                ? ((100 * this.getProyeccion(item)) / item.objetivo).toFixed(2)
                : 0;
        },
    },
    watch: {
        selectMonth: {
            handler(val) {
                if (val) {
                    this.date.setMonth(val.split('-')[1] - 1);
                    this.calculateCommercialDays();
                }
            },
            immediate: true,
        },
        consec_total() {
            this.selectedObjectiveIndex = 0;
        },
        selectedObjectiveIndex(val) {
            this.valAnimatedAux = 0;
            this.valAnimated = 0;
            this.valAnimatedAux1 = 0;
            this.valAnimated1 = 0;

            this.value = 0;
            this.value1 = 0;

            if (
                Object.keys(this.consec_count).length > 0 &&
                this.consec_count[Object.keys(this.consec_count)[val]]
                    .objetivo != 0
            ) {
                this.selectedObjective =
                    this.consec_count[Object.keys(this.consec_count)[val]];
                this.value =
                    (this.consec_count[Object.keys(this.consec_count)[val]]
                        .consecucion /
                        this.consec_count[Object.keys(this.consec_count)[val]]
                            .objetivo) *
                    100;
                this.value1 = this.getProyeccionPercent(
                    this.consec_count[Object.keys(this.consec_count)[val]]
                );
            }

            this.valAnimated = this.value;
            this.valAnimated1 = this.value1;
        },
        consec_count() {
            this.selectedObjective = this.consec_count.length ? this.consec_count[0] : null;
        },
        isLoading() {
            if (Object.keys(this.consec_count).length > 0) {
                this.value =
                    (this.consec_count[Object.keys(this.consec_count)[0]]
                        .consecucion /
                        this.consec_count[Object.keys(this.consec_count)[0]]
                            .objetivo) *
                    100;

                if (this.selectMonth && this.selectMonth != this.dateActualInmutable.toISOString().slice(0, 7)) {
                    this.value1 = this.value;
                } else{
                    if(!this.isLoading){
                        this.value1 = this.getProyeccionPercent(
                            this.consec_count[Object.keys(this.consec_count)[0]]
                        );
                    }
                }
                this.valAnimated = this.value;
                this.valAnimated1 = this.value1;
            }
        },
    },
};
</script>